import axios, { type AxiosResponse, type InternalAxiosRequestConfig } from 'axios';

import { env } from '@/config/env';

const apiClient = axios.create({
  baseURL: env.VITE_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 15_000,
});

// In-memory headers bridge — stores call these to inject the assessment token
// into axios without circular imports (token is NEVER stored in localStorage)
let _assessmentToken: string | null = null;

export const apiHeaders = {
  setAssessmentToken: (token: string) => {
    _assessmentToken = token;
  },
  clearAssessmentToken: () => {
    _assessmentToken = null;
  },
};

apiClient.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  if (_assessmentToken) {
    config.headers['X-Assessment-Token'] = _assessmentToken;
  }
  // When sending FormData, delete the default Content-Type so axios can set
  // multipart/form-data with the correct boundary automatically.
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }
  return config;
});

// The backend wraps every response in { statusCode, status, message, data, timestamp }.
// Unwrap to expose the actual payload directly as response.data.
apiClient.interceptors.response.use((response: AxiosResponse) => {
  if (response.data !== null && typeof response.data === 'object' && 'data' in response.data) {
    response.data = response.data.data;
  }
  return response;
});

export { apiClient };
